import { DeleteConfirmationModal } from '@/shared/ui/DeleteConfirmationModal';
import { KnowledgeBaseDeleteFormProps } from './KnowledgeBaseDeleteForm.types';
import { useTranslation } from 'react-i18next';

export const KnowledgeBaseDeleteForm = ({
  open,
  isDeleting,
  onCancel,
  onConfirmDelete,
  knowledgeBaseName,
}: KnowledgeBaseDeleteFormProps) => {
  const { t } = useTranslation('knowledge');

  return (
    <DeleteConfirmationModal
      open={open}
      isDeleting={isDeleting}
      onCancel={onCancel}
      onConfirmDelete={onConfirmDelete}
      resourceType={t('knowledgeBase.knowledgeBase')}
      resourceName={knowledgeBaseName}
      warningMessage={t('knowledgeBases.knowledgeBaseDeleteForm.thisActionIsIrreversibleBy')}
      data-testid="kb-delete-modal"
    />
  );
};

KnowledgeBaseDeleteForm.displayName = 'KnowledgeBaseDeleteForm';
